import script from "D:\\Games\\van\\van3\\v3\\ui\\GameShell.vue?type=script"
export * from "D:\\Games\\van\\van3\\v3\\ui\\GameShell.vue?type=script"

import "D:\\Games\\van\\van3\\v3\\ui\\GameShell.vue?type=style&index=0"
export default script
script.__scopeId = "data-v-ba671ee2"